import { stddev } from '../utils/statistics.js';

export class KeystrokeTracker {
  constructor(inputElement, targetText) {
    this.input = inputElement;
    this.target = targetText;
    this.events = [];
    this.startTime = null;
    this.startedAtWall = null;
    this.errorCount = 0;
    this.correctedCount = 0;

    this._boundKeyDown = this._onKeyDown.bind(this);
    this._boundPaste = (e) => e.preventDefault();
    this._boundInput = this._onInput.bind(this);

    this.input.addEventListener('keydown', this._boundKeyDown);
    this.input.addEventListener('paste', this._boundPaste);
    this.input.addEventListener('input', this._boundInput);
    this.input.setAttribute('autocorrect', 'off');
    this.input.setAttribute('autocapitalize', 'off');
    this.input.setAttribute('spellcheck', 'false');
    this.input.setAttribute('autocomplete', 'off');
  }

  _onKeyDown(e) {
    if (this.startTime === null) {
      this.startTime = performance.now();
      this.startedAtWall = new Date();
    }
    const t = performance.now() - this.startTime;

    if (e.key === 'Backspace') {
      this.correctedCount++;
      this.events.push({ key: e.key, t, type: 'backspace' });
      return;
    }

    if (e.key.length === 1) {
      if (/[\u0400-\u04FF]/.test(e.key)) {
        e.preventDefault();
        this.wrongLayoutCount = (this.wrongLayoutCount || 0) + 1;
        this.events.push({ key: e.key, t, type: 'wrong-layout' });
        this.input.dispatchEvent(new CustomEvent('wrong-layout', { bubbles: true }));
        return;
      }
      const expectedChar = this.target[this.input.value.length];
      if (e.key !== expectedChar) {
        this.errorCount++;
      }
      this.events.push({ key: e.key, t, type: 'printable' });
    }
  }

  _onInput() {}

  computeMetrics() {
    const printableEvents = this.events.filter((e) => e.type === 'printable');
    const iki = [];
    for (let i = 1; i < printableEvents.length; i++) {
      iki.push(printableEvents[i].t - printableEvents[i - 1].t);
    }

    const allEvents = this.events;
    const duration = allEvents.length > 0 ? allEvents[allEvents.length - 1].t : 0;
    const charCount = this.input.value.length;
    const wpm = duration > 0 ? charCount / 5 / (duration / 60000) : 0;
    const stddevIki = stddev(iki);
    const pauseCount = iki.filter((x) => x > 300).length;
    const textMatches = this.input.value.trim().toLowerCase() === this.target.toLowerCase();

    return {
      duration_ms: Math.round(duration),
      wpm: Math.round(wpm * 10) / 10,
      char_count: charCount,
      error_count: this.errorCount,
      corrected_count: this.correctedCount,
      text_matches: textMatches,
      stddev_iki: Math.round(stddevIki),
      pause_count: pauseCount,
      keystroke_intervals: iki.map((v) => Math.round(v)),
      startedAt: this.startedAtWall || new Date(),
      completedAt: new Date(),
    };
  }

  destroy() {
    this.input.removeEventListener('keydown', this._boundKeyDown);
    this.input.removeEventListener('paste', this._boundPaste);
    this.input.removeEventListener('input', this._boundInput);
  }
}
